import { Routes } from '@angular/router';

import { AuthLayoutComponent } from './layout/auth-layout/auth-layout.component';
import { DashboardLayoutComponent } from './layout/dashboard-layout/dashboard-layout.component';
import { authGuard } from './core/guards/auth.guard';
import { ReportHtmlComponent } from './modules/report/report-html/report-html.component';

export const routes: Routes = [
	{
		path: 'reportDownloadHtml/:id',
		component: ReportHtmlComponent,
		canActivate: [authGuard]
	},
	{
		path: '',
		component: DashboardLayoutComponent,
		canActivate: [authGuard],
		children: [
			{
				path: '',
				loadChildren: './modules/dashboard/dashboard.module#DashboardModule',
				data: {
					title: 'Dashboard Module'
				}
			}
		]
	},
	{
		path: 'auth',
		component: AuthLayoutComponent,
		children: [
			{
				path: '',
				loadChildren: './modules/auth/auth.module#AuthModule',
				data: {
					title: 'Auth Module'
				}
			}
		]
	},
	{
		path: 'trip',
		component: DashboardLayoutComponent,
		children: [
			{
				path: '',
				loadChildren: './modules/trip/trip.module#TripModule',
				data: {
					title: 'Trip Module'
				}
			}
		]
	},
	{
		path: 'report',
		component: DashboardLayoutComponent,
		children: [
			{
				path: '',
				loadChildren: './modules/report/report.module#ReportModule',
				data: {
					title: 'ReportModule'
				}
			}
		]
	},
	{
		path: 'settings',
		component: DashboardLayoutComponent,
		children: [
			{
				path: '',
				loadChildren: './modules/settings/settings.module#SettingsModule',
				data: {
					title: 'Settings Module'
				}
			}
		]
	},
	{
		path: '**',
		redirectTo: '/auth'
	}
];



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/MileTrack-Frontend-AWS-S3/src/app/app-routing.module.ts